import InlineText from 'components/elements/texts/InlineText'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'
import RequiredOptional from './RequiredOptional'

/**
 * ひとかたまりの選択肢のタイトル
 */
const FormTitle: React.FC<FormTitleProps> = (props) => {
  return (
    <React.Fragment>
      {props.hideTitle ? (
        <StyledEmptyTitle />
      ) : (
        <FormTitleWrap className={props.className}>
          {props.caution && <StyledCaution>{props.caution}</StyledCaution>}
          <StyledFormTitle className={props.className}>
            <InlineText bold={props.bold}>{props.title}</InlineText>
            <RequiredOptional
              isRequired={props.isRequired}
              isOption={props.isOption}
            />
          </StyledFormTitle>
        </FormTitleWrap>
      )}
      {props.description && (
        <StyledDescription>{props.description}</StyledDescription>
      )}
    </React.Fragment>
  )
}

export type FormTitleProps = {
  title: string
  addPhoto?: boolean
  isSinglePhoto?: boolean
  isOptional?: boolean
  isRequired?: boolean
  isOption?: boolean
  description?: string
  caution?: string
  hideTitle?: boolean
  option?: boolean
  cautionary?: string
  bold?: boolean
  className?: string
}

export const FormTitleWrap = styled.div`
  padding: 30px 16px 6px;
`

export const StyledCaution = styled.div`
  padding-bottom: 6px;
`

export const StyledFormTitle = styled.div`
  display: flex;
  align-items: center;
`

export const StyledEmptyTitle = styled.div`
  margin-top: 12px;
`

export const StyledDescription = styled(Text)`
  margin: 0px 16px 10px;
`

export default FormTitle
